/*
 * Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filtertool-ongekwalificeerdregel.ts
 * 31-08-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Claude (AI), 31-08-2026
 * Subclass voor regels die diensten filteren op ongekwalificeerd ingepland personeel.
 */

import {Filtertoolregel} from '../filtertool-regels';
import type {Planitem as PlanitemType} from '../../../models/planitem';
import {PlanitemFilterbareRegel} from '../filtertool-capabilities';

/**
 * Regel zonder parameters: houdt de diensten over waarop minstens één ingepland personeelslid een
 * functie van de dienst mist of waarvan de certificering op de dienstdatum verlopen is.
 */
export class FiltertoolPlanitemongekwalificeerdRegel extends Filtertoolregel implements PlanitemFilterbareRegel {
    constructor(init?: Partial<Filtertoolregel>) {
        super('planitemongekwalificeerd', init as any);
    }

    /**
     * Past de regel toe op een dienst. De beoordeling zelf staat in Planitem: die kent zowel de
     * ontbrekende functies als de verlopen certificeringen, en telt alleen bij een factureerbaar
     * project.
     * @param pi
     */
    public filterPlanitem(pi: PlanitemType): boolean {
        return pi.kwalificatieproblemen.length > 0;
    }
}
